export default __webpack_public_path__ + "static/media/user-list.80606fdd.png";